import { useEffect, useRef, useState } from 'react';
import { iconeAparado, quadrosDoRetrato } from '../world/retrato';

/** Os quadros do retrato (idle ou attack) de uma aparência; vazio enquanto carrega. */
export function useRetrato(aparencia: string, acao: 'idle' | 'attack' = 'idle', ligado = true) {
  const [q, setQ] = useState<string[]>([]);
  useEffect(() => {
    if (!ligado || !aparencia) return;
    let vivo = true;
    void quadrosDoRetrato(aparencia, acao).then(x => { if (vivo) setQ(x); });
    return () => { vivo = false; };
  }, [aparencia, acao, ligado]);
  return q;
}

/** O rosto redondo do mob (V3 · 02 .ch-face). */
export function FaceMob({ aparencia, px, titulo }: { aparencia: string; px: number; titulo?: string }) {
  const [src] = useRetrato(aparencia);
  return (
    <span className="ch-face" style={{ width: px, height: px }} title={titulo}>
      {src ? <img src={src} alt="" draggable={false} /> : null}
    </span>
  );
}

/** O retrato grande: o primeiro quadro do idle; com o mouse em cima, toca a folha idle (Renato, 21/10: não a de ataque). */
export function RetratoAnimado({ aparencia, alt }: { aparencia: string; alt: string }) {
  const quadros = useRetrato(aparencia);
  const parado = quadros[0];
  const [sobre, setSobre] = useState(false);
  const [k, setK] = useState(0);
  const timer = useRef(0);
  useEffect(() => {
    if (!sobre || quadros.length < 2) { setK(0); return; }
    timer.current = window.setInterval(() => setK(n => (n + 1) % quadros.length), 1000 / 8);
    return () => window.clearInterval(timer.current);
  }, [sobre, quadros.length]);
  const src = sobre && quadros.length ? quadros[k % quadros.length] : parado;
  return src
    ? <img src={src} alt={alt} draggable={false} onPointerEnter={() => setSobre(true)} onPointerLeave={() => setSobre(false)} />
    : <span className="sr">{alt}</span>;
}

/** <img> com o ícone recortado no contorno (o desenho ocupa a casa). Enquanto recorta, mostra o original. */
export function ImgAparada({ src, className, alt = '', title, style }: { src: string; className?: string; alt?: string; title?: string; style?: React.CSSProperties }) {
  const [url, setUrl] = useState(src);
  useEffect(() => {
    let vivo = true;
    setUrl(src);
    void iconeAparado(src).then(u => { if (vivo) setUrl(u); });
    return () => { vivo = false; };
  }, [src]);
  return <img className={className} src={url} alt={alt} title={title} style={style} draggable={false} />;
}
